export default "__VITE_ASSET__25951ff5__"